import * as React from 'react';
export const gopaySvg = React.forwardRef(function gopaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00AED6',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M25.985 15.483a3.79 3.79 0 0 0-1.303-2.64 4.086 4.086 0 0 0-2.854-.994H11a.743.743 0 0 1-.507-.204.689.689 0 0 1-.208-.489c0-.383.32-.693.715-.693h10.97a3.226 3.226 0 0 0-.733-1.918 3.438 3.438 0 0 0-1.766-1.135 28.66 28.66 0 0 0-9.664 0 4.615 4.615 0 0 0-2.304 1.341 4.338 4.338 0 0 0-1.124 2.357 31.993 31.993 0 0 0 0 9.836 4.602 4.602 0 0 0 1.356 2.433 4.9 4.9 0 0 0 2.55 1.265c3.968.477 7.982.477 11.95 0a4.241 4.241 0 0 0 2.241-1.23 3.978 3.978 0 0 0 1.073-2.26c.352-1.87.5-3.77.435-5.669Zm-3.556 2.326v.616a.668.668 0 0 1-.208.489.718.718 0 0 1-.507.204.74.74 0 0 1-.506-.204.689.689 0 0 1-.208-.49v-.615a1.028 1.028 0 0 1-.33-.527.998.998 0 0 1 .04-.614 1.04 1.04 0 0 1 .394-.484 1.104 1.104 0 0 1 1.22 0c.18.12.317.288.395.484.077.196.091.41.04.614a1.028 1.028 0 0 1-.33.527Z',
      fill: '#fff',
    }),
  );
});
gopaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gopay = {
  category: 'brand',
  colorable: false,
  name: 'gopay',
  svg: gopaySvg,
};
